/* eslint-disable no-magic-numbers */

import { lineChunk, lineString } from "@turf/turf";
import { coordEach, coordAll } from "@turf/meta";
import { fetchAltitudes } from "./altitude-api.mjs";
import L from "leaflet";

function addPointsToLineString(geojson, distance) {
  const chunkedLineString = lineChunk(geojson, distance);
  return lineString(coordAll(chunkedLineString));
}

async function addAltitudeToGeojson(geojson) {
  const geojsonWithAltitude = JSON.parse(JSON.stringify(geojson));
  const coordinates = coordAll(geojsonWithAltitude);
  const altitudes = await fetchAltitudes(coordinates);
  let index = 0;

  coordEach(geojsonWithAltitude, (coord) => {
    coord[2] = altitudes[index];
    index += 1;
  });

  return geojsonWithAltitude;
}

async function addAltitudeToLayer(layer) {
  const geojson = layer.toGeoJSON();
  const chunkedGeojson = addPointsToLineString(geojson, 0.05);
  const geojsonWithAltitude = await addAltitudeToGeojson(chunkedGeojson);
  return L.geoJSON(geojsonWithAltitude);
}

function sumAltitudes(altitudes, treshold) {
  let elevationGain = 0;
  let elevationLoss = 0;
  let previousAltitude = altitudes.shift();

  for (const currentAltitude of altitudes) {
    const diff = currentAltitude - previousAltitude;

    if (diff > treshold) {
      elevationGain += diff;
      previousAltitude = currentAltitude;
    }

    if (diff < -treshold) {
      elevationLoss += diff;
      previousAltitude = currentAltitude;
    }
  }

  return {
    elevationGain: Math.round(elevationGain),
    elevationLoss: Math.round(-elevationLoss),
  };
}

function getElevationGainAndLoss(geojson) {
  const ALTITUDE_TRESHOLD = 10;
  const altitudes = coordAll(geojson).map((coord) => coord[2]);
  return sumAltitudes(altitudes, ALTITUDE_TRESHOLD);
}

export { getElevationGainAndLoss, addAltitudeToLayer };
